import React, { useState } from 'react';

const ToggleSwitch = ({ onChange, value }) => {
  const [isOn, setIsOn] = useState(value);

  const toggleButton = () => {
    onChange(!isOn);
    setIsOn(!isOn);
  };

  return (
    <button className={`animated-button ${isOn ? 'on' : 'off'}`} onClick={toggleButton}>
      {isOn ? 'ON' : 'OFF'}
      <span className='slide-bg'></span>
    </button>
  );
};

export default ToggleSwitch;
